module.exports = __webpack_public_path__ + "img/analytics.5677952e.svg";